/** Still-image viewer: fit to the stage, click to view at 100 %, with the source size shown. */
import { useState } from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';
import type { AssetDetail } from '@prism/contracts';

export function ImageViewer({ asset }: { asset: AssetDetail }) {
  const [actual, setActual] = useState(false);
  const proxy = asset.representations.find((r) => r.kind === 'proxy');
  const shown = proxy?.attributes as { width?: number; height?: number } | undefined;
  return (
    <div className="player image-viewer" data-testid="image-viewer">
      <div className={`image-stage ${actual ? 'actual' : ''}`} onClick={() => setActual(!actual)} title={actual ? 'Fit to view' : 'View at full preview size'}>
        <img src={asset.media.proxyUrl!} alt={asset.title} draggable={false} />
      </div>
      <div className="controls" style={{ justifyContent: 'space-between' }}>
        <span className="muted mono" style={{ fontSize: 12 }}>
          {asset.width}×{asset.height}{shown?.width && shown.width !== asset.width ? ` · preview ${shown.width}×${shown.height}` : ''}
        </span>
        <button className="btn ghost sm" onClick={() => setActual(!actual)}>{actual ? <Minimize2 size={14} /> : <Maximize2 size={14} />} {actual ? 'Fit' : '100 %'}</button>
      </div>
    </div>
  );
}
